function waitForElement(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

async function hideRechargeSubs() {
    const rechargeSubsWidgetEl = await waitForElement('.shopify-block.recharge-subscription-widget');
    rechargeSubsWidgetEl.setAttribute("style","display: none !important;");
}

async function showRechargeSubs() {
    const rechargeSubsWidgetEl = await waitForElement('.shopify-block.recharge-subscription-widget');
    rechargeSubsWidgetEl.removeAttribute("style");
}

function parseJSONByAttribute(attr, fallback = []) {
    try {
        const el = document.querySelector(attr);
        return el ? JSON.parse(el.textContent.trim()) : fallback;
    } catch (e) {
        console.warn('Failed to parse JSON', e);
        return fallback;
    }
}

function disableAtcButton() {
    const atcButtonEls = document.querySelectorAll('button.product-form__cart-submit');
    if (atcButtonEls.length) {
        atcButtonEls.forEach(atcButtonEl => {
            atcButtonEl.setAttribute("disabled","disabled");
            const textEl = atcButtonEl.querySelector('[data-add-to-cart-text]');
            textEl.innerHTML = "Sold out";
        });
    }
}

function enableAtcButton() {
    const atcButtonEls = document.querySelectorAll('button.product-form__cart-submit');
    if (atcButtonEls.length) {
        atcButtonEls.forEach(atcButtonEl => {
            atcButtonEl.removeAttribute("disabled","disabled");
            const textEl = atcButtonEl.querySelector('[data-add-to-cart-text]');
            textEl.innerHTML = "Add to Cart";
        });
    }
}

/*
 * List of SKUs of Deos for which Recharge Subscription widget is to be hidden:
 * - PF - Coconut & Vanilla (SKU: 80797018)
 * - PF - Cucumber & Mint (SKU: 80804325)
 * - PF - Eucalyptus & Mint (SKU: 80797019)
 * - PF - Lilac & White Tea (SKU: 80797020)
 * - Sensitive Unscented (SKU: 80797017)
*/
const pfSkusToHideSubs = ["80797018", "80804325", "80797019", "80797020", "80797017"];

// Get Variants Data from one of the HTML elements of the page
const variantsData = parseJSONByAttribute('[data-variant-json]');

// Create a Map to make it easy to lookup the SKUs {variantId -> variantSku}
const variantsSkuMap = new Map(
    variantsData.map(v => [String(v.id), String(v.sku)])
);

    // Listen to the theme's custom events
        // Event: Page Load
document.addEventListener('DOMContentLoaded', function(loadEvt) {
    // Get current or default variant SKU
    const currentVariantId = document.querySelector('[data-current-product-id]').getAttribute('data-current-product-id');
    const currentVariantSku = String(variantsSkuMap.get(currentVariantId)) || "";
    // Check if the subscription widget should be hidden for the current variant SKU
    if (pfSkusToHideSubs.includes(currentVariantSku)) {
        hideRechargeSubs();
        disableAtcButton();
    } else {
        showRechargeSubs();
    }
});

    // Event: Variant Change
document.addEventListener("product:variant-change", function (evt) {
    if (!evt.detail?.variant) return;
    // Get current or default variant SKU
    const variantId = String(evt.detail.variant.id);
    const variantSku = String(variantsSkuMap.get(variantId)) || "";
    // Check if the subscription widget should be hidden for the current variant SKU
    if (pfSkusToHideSubs.includes(variantSku)) {
        hideRechargeSubs();
        disableAtcButton();
    } else {
        showRechargeSubs();
    }
});
